import React from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { Link } from 'react-router';

const PreviewAction = ({
  location = {},
  location: { query = {} },
  assessmentId,
  previewOpened,
  subjectInfo = {},
  isVideo,
  assessmentPreviewURL,
  videoProviderId,
  isSPP,
  disabled,
}) => {
  const { id: masterSubjectId } = subjectInfo || {};

  const buildGoTo = (customQuery = {}, locationOverride = {}) => ({
    ...location,
    ...locationOverride,
    query: {
      ...query,
      ...customQuery,
    },
  });
  let customQuery = {};
  if (isVideo) {
    customQuery = { apd: videoProviderId };
  } else if (!isSPP) {
    customQuery = { quizId: assessmentId };
  }

  let goTo = '';
  if (isSPP) {
    goTo = buildGoTo(
      {},
      {
        pathname: `/${masterSubjectId}/assessments/spp/preview/${assessmentId}`,
        state: {
          returnPath: `${location.pathname}${location.search}`,
        },
      },
    );
  } else if (!!assessmentPreviewURL) {
    goTo = assessmentPreviewURL;
  } else {
    goTo = buildGoTo(customQuery);
  }

  return (
    <AccessibilityWrapper disableAutoFocus>
      <Link
        to={goTo}
        tabIndex={-1}
        aria-label={
          isVideo ? 'Preview Video' : isSPP ? 'Preview' : 'Preview Quiz'
        }
        onClick={previewOpened}
        disabled={disabled}
      >
        <SingleAction iconName="preview" disabled={disabled}>
          <span className="item-text">
            {isVideo ? 'Preview Video' : isSPP ? 'Preview' : 'Preview Quiz'}
          </span>
        </SingleAction>
      </Link>
    </AccessibilityWrapper>
  );
};

export default PreviewAction;
